<script setup lang="ts">
import { ListingFilter } from '@shopware-pwa/types'

interface LanugageOption {
  value: string
  label: string
}
const props = defineProps<{
  filter: ListingFilter
  currentFilters: {
    properties: string[]
  }
}>()

const emits = defineEmits<{
  (e: 'select-value', value: { code: string; value: string[] }): void
}>()

const { t } = useI18n()

// includes other "properties" than language
const properties = computed(() => props.currentFilters?.properties || [])
const languages: ComputedRef<LanugageOption[]> = computed(() => {
  return [...(props.filter.options || []), ...(props.filter.entities || [])].map((option) => ({
    value: option.id,
    label: option.translated.name,
  }))
})
const languageIds = computed(() => options.value.map((option) => option.value))
const options: ComputedRef<LanugageOption[]> = computed(() => {
  return [
    {
      value: 'all',
      label: t('shop.listingPage.filters.language.all'),
    },
    ...languages.value,
  ]
})
const selectedOption = ref<string>(properties.value.find((property) => languageIds.value.includes(property)) || 'all')

const changeLanguage = (value: string) => {
  // remove any language id from the current selection
  const selection = properties.value.filter((property) => !languageIds.value.includes(property))

  if (value !== 'all') {
    selection.push(value)
  }

  emits('select-value', {
    code: props.filter.code,
    value: selection,
  })
}
</script>

<template>
  <div class="filter-select">
    <Select
      v-model="selectedOption"
      :name="`filter-${filter.name}`"
      :required="false"
      :label="filter.label"
      :options="options"
      @input="changeLanguage"
    />
  </div>
</template>
